export default __webpack_public_path__ + "static/media/folder-right.dc77a6a2.svg";